package de.connect2x.timmy

import de.connect2x.lognity.api.logger.Level
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json

private val json = Json {
    ignoreUnknownKeys = true
}

suspend fun loadConfig(): EnvironmentConfig {
    val response = window.fetch("/config.json", js("{}")).await()
    val jsonText = response.text().await()
    return json.decodeFromString<EnvironmentConfig>(jsonText)
}

@kotlinx.serialization.Serializable
data class EnvironmentConfig(
    val versionCheckUrl: String = "",
    val vzdUrl: String = "",
    val idpUrl: String = "",
    val homeServerUrl: String = "",
    val downloadsDisabled: Boolean = false,
    val csvExportDisabled: Boolean = true,
    val filePreviewDisabled: Boolean = true,
    val logLevel: Level = Level.INFO,
    val brand: Brand = Brand.LIFETIME,
)
